import { render, staticRenderFns } from "./DirectTeachingActivityForm.vue?vue&type=template&id=19a5e028&scoped=true"
import script from "./DirectTeachingActivityForm.vue?vue&type=script&lang=js"
export * from "./DirectTeachingActivityForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=19a5e028&prod&scoped=true&lang=css&external"
import style1 from "./DirectTeachingActivityForm.vue?vue&type=style&index=1&id=19a5e028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5e028",
  null
  
)

export default component.exports